import React from 'react'

const ClearFilterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      fill="#F7F7FA"
    />
    <path
      d="M7.39215 7.0443L7.42678 7.07322L10 9.6465L12.5732 7.07322C12.6709 6.97559 12.8291 6.97559 12.9268 7.07322C13.0136 7.16001 13.0232 7.29472 12.9557 7.39215L12.9268 7.42678L10.3535 10L12.9268 12.5732C13.0244 12.6709 13.0244 12.8291 12.9268 12.9268C12.84 13.0136 12.7053 13.0232 12.6078 12.9557L12.5732 12.9268L10 10.3535L7.42678 12.9268C7.32915 13.0244 7.17085 13.0244 7.07322 12.9268C6.98644 12.84 6.9768 12.7053 7.0443 12.6078L7.07322 12.5732L9.6465 10L7.07322 7.42678C6.97559 7.32915 6.97559 7.17085 7.07322 7.07322C7.16001 6.98644 7.29472 6.9768 7.39215 7.0443Z"
      fill="#8E8E93"
      stroke="#8E8E93"
    />
  </svg>

)

export default ClearFilterIcon
